import { render, staticRenderFns } from "./BooleanRadios.vue?vue&type=template&id=22260118&scoped=true&"
import script from "./BooleanRadios.vue?vue&type=script&lang=ts&"
export * from "./BooleanRadios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22260118",
  null
  
)

export default component.exports